<template>
  <div class="brand-container simple-search-table-container default-table">
    <div class="head">
      <div>
        <el-input v-model="queryParams.name" placeholder="模糊查询品牌名称" size="mini"/>
        <el-button type="primary" size="mini" @click="handelSearch">查询</el-button>
      </div>
      <el-button v-if="userAuth.can_add_brand" type="primary" size="mini" @click="handelCreate">新增</el-button>
    </div>

    <ape-table ref="apeTable" :data="tableData" :loading="loading" :paging-data="configPage"
               @switchPaging="getTableData"
               highlight-current-row border is-full-height>
      <el-table-column prop="name" label="品牌名称" header-align="center" align="center" width="150"
                       show-overflow-tooltip/>
      <el-table-column label="品牌集团" align="center" show-overflow-tooltip min-width="100">
        <template slot-scope="{row}">
          <store-combine
              v-if="userAuth.can_brand_list_combine"
              :data="{id:row.id,name:row.name,combine_name:row.combine&&row.combine.name?row.combine.name:null}"
              @success="getTableData"/>
        </template>
      </el-table-column>
      <el-table-column prop="tag_custom" label="分类标签" header-align="center" align="center" width="150"
                       show-overflow-tooltip>
        <template slot-scope="{row}">
          <store-tag :data="{id:row.id,name:row.name,tag_custom:row.tag_custom}" @success="getTableData"/>
        </template>
      </el-table-column>
      <el-table-column label="大牌标签" header-align="center" align="center" min-width="120">
        <template slot-scope="{row}">
          <span v-if="row.is_famous ===MapFamous.Y" style="color: #ff3176">是</span>
          <span v-else-if="row.is_famous ===MapFamous.N">否</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center" min-width="160" show-overflow-tooltip/>
      <el-table-column prop="created_at" label="创建时间" header-align="center" align="center" min-width="120"/>
      <el-table-column prop="updated_at" label="修改时间" header-align="center" align="center" min-width="120"/>
      <el-table-column label="操作" header-align="center" align="center" min-width="120">
        <template slot-scope="{row}">
          <el-button v-if="userAuth.can_update_brand" type="text" size="mini" icon="el-icon-edit"
                     @click="handelUpdate(row)">修改
          </el-button>
          <el-button v-if="userAuth.can_delete_brand" type="text" size="mini" icon="el-icon-delete"
                     @click="handelDelete(row)">删除
          </el-button>
        </template>
      </el-table-column>
    </ape-table>

    <el-dialog :title="formStore.type==='CREATE'?'新增品牌':'编辑品牌'" :visible.sync="dialogStore" width="580px"
               center>
      <el-form label-width="80px" :model="formStore" size="mini">
        <el-form-item label="品牌名称">
          <el-input v-model="formStore.name" maxlength="40" show-word-limit/>
        </el-form-item>
        <el-form-item label="是否大牌">
          <el-radio-group v-model="formStore.is_famous" size="small">
            <el-radio label="Y">是</el-radio>
            <el-radio label="N">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="`备\u3000\u3000注`">
          <el-input v-model="formStore.remark" type="textarea" maxlength="80" show-word-limit/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogStore = false">取 消</el-button>
        <el-button type="primary" @click="handelStoreSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ApeTable from "@/components/ApeTable.vue";
import StoreCombine from "./components/StoreCombine.vue";
import StoreTag from "./components/StoreTag.vue";
import {brandDelete, brandPage, brandStore} from "@/api/brand";

const MapFamous = {
  Y: 'Y',
  N: 'N',
}
const ModelFormStore = {
  type: 'CREATE',
  name: null,
  is_famous: 'N',
  remark: null,
  id: null,
}
const ConfigPage = {
  is_show: true,
  layout: 'total, sizes, prev, pager, next, jumper',
  total: 0,
  page_size: 30,
  page: 1,
}
export default {
  name: "index",
  components: {ApeTable, StoreCombine, StoreTag},
  data() {
    return {
      MapFamous,
      configPage: ConfigPage,
      loading: false,
      dialogStore: false,
      formStore: {...{}, ...ModelFormStore},
      queryParams: {name: null},
      tableData: []
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  mounted() {
    this.getTableData()
  },
  methods: {
    handelCreate() {
      this.formStore = {...{}, ...ModelFormStore}
      this.dialogStore = true;
    },
    handelUpdate(obj) {
      this.formStore = {
        type: 'UPDATE',
        name: obj.name,
        is_famous: obj.is_famous,
        remark: obj.remark,
        id: obj.id,
      }
      this.dialogStore = true;
    },
    handelDelete(obj) {
      this.showModal({
        h: this,
        text: `确认删除【${obj.name}】吗？`,
        confirmText: "",
        cancelText: "",
        confirm: async () => {
          const response = await brandDelete({id: obj.id})
          if (!response.success) {
            this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
            return;
          }
          this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
          await this.getTableData()
        }
      });
    },
    async handelStoreSure() {
      if (!this.formStore.name) {
        this.showToast({h: this, icon: "el-icon-error", text: '请填写品牌名称', duration: 2000});
        return false;
      }
      const response = await brandStore(this.formStore)
      if (!response.success) {
        this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
        return;
      }
      this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
      await this.getTableData()
      this.dialogStore = false;
    },
    handelSearch() {
      this.getTableData(true)
    },
    getParams(isSearch) {
      let pageInfo = this.$refs['apeTable'].getPagingInfo()
      const params = {...this.queryParams, ...pageInfo}
      params.page = isSearch ? 1 : pageInfo.current_page
      return params
    },
    async getTableData(isSearch = false) {
      const response = await brandPage(this.getParams(isSearch))
      this.tableData = response.model.data || []
      this.configPage.total = response.model.total || 0
    }
  }
}
</script>

<style lang="scss">
.brand-container {
  .head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .el-input {
      width: 250px;
      margin-right: 12px;
    }
  }

  .el-table {
    margin-bottom: 10px;
  }
}
</style>
